<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">售后订单</div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <div style="display: flex; align-items: end; gap: 10px;">
                    <el-form-item label="订单编号" class="form-item-order-id">
                        <el-input v-model="searchForm.orderNumber" placeholder="请输入" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="售后方式" class="form-item-name">
                        <el-select size="small" v-model="searchForm.afterSalesType" placeholder="请选择售后方式">
                            <el-option value="1" label="仅退款"></el-option>
                            <el-option value="2" label="退货退款"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="申请时间" class="form-item-date">
                        <el-date-picker v-model="searchForm.orderTime" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" size="small"></el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-item-reset">
                        <el-button type="default" size="small" @click="resetSearch">重置</el-button>
                    </el-form-item>
                    <el-form-item class="form-item-search">
                        <el-button type="primary" size="small" @click="searchOrders">查询</el-button>
                    </el-form-item>
                </div>
                <!-- <div style="display: flex; align-items: end; gap: 10px;">
                    <el-form-item label="收货人姓名" class="form-item-name">
                        <el-input v-model="searchForm.receiverName" placeholder="请输入" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="收货人手机号" class="form-item-phone">
                        <el-input v-model="searchForm.receiverPhone" placeholder="请输入" size="small"></el-input>
                    </el-form-item>
                </div> -->
            </el-form>
        </div>
        <!-- 订单状态标签 -->
        <div class="status-tabs">
            <el-radio-group v-model="activeStatus" size="small" class="status-radio-group" @change="handleStatusChange">
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="apply">申请中</el-radio-button>
                <el-radio-button label="send_back">待寄回</el-radio-button>
                <el-radio-button label="have_refund">已退款</el-radio-button>
                <el-radio-button label="have_refused">已拒绝</el-radio-button>
            </el-radio-group>
        </div>
        <!-- 订单表格 -->
        <el-table :data="tableData" :border="true" style="width: 100%" class="order-table" :span-method="spanMethod">
            <!-- 商品信息列 - 使用模板显示复杂内容 -->
            <el-table-column label="商品信息" width="400" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.type == 'header'" class="order-header">
                        <!-- <span>{{ scope.row.create_time }}</span> -->
                        <span>订单编号：{{ scope.row.order_sn }}</span>
                    </div>
                    <!-- 商品行 -->
                    <div v-else class="goods-info">
                        <img :src="scope.row.goods.goods_thumb" alt="" class="goods-image" />
                        <div class="goods-details">
                            <div class="goods-name">{{ scope.row.goods.goods_name }}</div>
                            <div style="display: flex; align-items: center; gap: 10px;">
                                <div class="goods-spec">{{ scope.row.goods.sku_name }}</div>
                                <div class="goods-price">
                                    <span>¥{{ scope.row.goods.shop_price }}</span>
                                    <!-- <span>/棵</span> -->
                                </div>
                            </div>
                        </div>
                        <div class="goods-num">x{{ scope.row.goods.num }}</div>
                    </div>
                </template>
            </el-table-column>
            <!-- 买家信息列 -->
            <el-table-column label="买家" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.type" class="buyer-info">
                        <div class="buyer-name">{{ scope.row.buy_name }}</div>
                        <div class="buyer-phone">{{ scope.row.buy_mobile }}</div>
                    </div>
                </template>
            </el-table-column>
            <!-- 金额列 -->
            <el-table-column label="金额" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.type">
                        <div class="amount-label">实付</div>
                        <div class="amount-value">¥{{ scope.row.goods_money }}</div>
                    </div>
                </template>
            </el-table-column>
            <!-- 状态列 -->
            <el-table-column label="状态" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.type" class="trade-buttons">
                        <div class="status-text">{{ scope.row.refund_status_txt }}</div>
                        <el-button type="text" class="text-btn" @click="viewOrderDetail(scope.row)">
                            订单详情
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            <!-- 交易操作列 -->
            <el-table-column label="交易操作" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="!scope.row.type">
                        <el-button type="text" class="text-btn" @click="handleAgreeRefund(scope.row)" v-if="scope.row.status == '0' || scope.row.status == '1'">
                            同意退款
                        </el-button>
                        <el-button type="text" class="text-btn" @click="handleRefuseRefund(scope.row)" v-if="scope.row.status == '0'">
                            拒绝退款
                        </el-button>
                        <el-button type="text" class="text-btn" @click="handleConfirmRefund(scope.row)" v-if="scope.row.status == '1'">
                            确认退款
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="totalOrders"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currentPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AfterOrderList',
    data() {
        return {
            // 搜索表单
            searchForm: {
                afterSalesType: '',
                orderNumber: '',
                orderTime: ['', ''],
                receiverName: '',
                receiverPhone: ''
            },
            // 状态标签
            activeStatus: 'all',
            // 订单列表
            orders: [],
            // 分页信息
            totalOrders: 0,
            pageSize: 10,
            currentPage: 1
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        // 处理表格数据，合并订单头部行
        tableData() {
            const result = []
            this.orders.forEach(order => {
                // 添加订单头部行
                result.push({
                    id: `${order.aid}-header`,
                    type: 'header',
                    order_sn: order.order_sn,
                    create_time: order.create_time,
                    order_aid: order.aid
                })
                result.push(order)
            })
            return result
        }
    },
    mounted() {
        this.getOrdersList();
    },
    methods: {
        // 确认退款 
        handleConfirmRefund(item){
            this.$confirm('确定退款吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.confirmRefund({
                    refund_id: item.aid
                }).then(res => {
                    this.$message.success('退款成功');
                    this.getOrdersList();
                }).catch(err => {
                    this.$message.warning(err)
                })
            })    
        },
        // 同意退款
        handleAgreeRefund(item) {
            this.$confirm('确认同意退款？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$api.agreeRefund({
                    refund_id: item.aid
                }).then(res => {
                    this.$message.success('同意退款成功');
                    this.getOrdersList();
                }).catch(err => {
                    this.$message.warning(err)
                })
            }).catch(() => {

            });
        },
        // 拒绝退款
        handleRefuseRefund(item) {
            this.$prompt('请填写拒绝原因？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(({ value }) => {
               if(!value){
                    this.$message.warning('请输入拒绝原因');
                    return;
               }
               this.$api.refuseRefund({
                    refund_id: item.aid,
                    reject_reason: value
               }).then(res => {
                    this.$message.success('拒绝退款成功');
                    this.getOrdersList();
               }).catch(err => {
                    this.$message.warning(err)
               })
            }).catch(() => {
                
            });
        },
        // 单元格合并方法
        spanMethod({ row, column, rowIndex, columnIndex }) {
            // 订单头部行合并所有列
            if (row.type == 'header') {
                return {
                    rowspan: 1,
                    colspan: 5
                }
            }
        },
        // 获取订单列表
        getOrdersList() {
            this.$api.getShopAfterOrderList({
                partner_id: this.userInfo.user_merchant_id,
                type: this.activeStatus,
                order_type: '0',
                page: this.currentPage,
                list_rows: this.pageSize,
                keywords: this.searchForm.orderNumber,
                start_time: this.searchForm.orderTime[0] || '',
                end_time: this.searchForm.orderTime[1] || '',
                after_sale: this.searchForm.afterSalesType || '',
            }).then(res => {
                this.orders = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        // 搜索订单
        searchOrders() {
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 重置搜索条件
        resetSearch() {
            this.searchForm = {
                orderNumber: '',
                orderTime: ['', ''],
                receiverName: '',
                receiverPhone: '',
                afterSalesType: ''
            };
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 处理状态标签切换
        handleStatusChange() {
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 查看订单详情
        viewOrderDetail(item) {
            this.$emit('goToComponent', 'AfterOrderDetail', {
                after_id: item.aid,
                partner_id: this.userInfo.user_merchant_id
            });
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOrdersList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getOrdersList();
        }
    }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.my-orders-container {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 搜索区域 */
.search-section {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.search-form {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: start;
}

/* 为每个表单项目设置固定宽度 */
.form-item-order-id {
    width: 200px;
    text-align: left;
}

.form-item-name {
    width: 200px;
    text-align: left;
}

.form-item-phone {
    width: 200px;
    text-align: left;
}

.form-item-date {
    width: 300px;
    text-align: left;
}

/* 确保输入框和日期选择器占满表单项目宽度 */
.search-form .el-input,
.search-form .el-date-editor {
    width: 100%;
}

/* 订单状态标签 */
.status-tabs {
    margin-bottom: 20px;
}

.status-radio-group {
    display: flex;
    align-items: center;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格自定义样式 */
.order-table {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.order-header {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    min-height: 80px;
    flex: 1;
    text-align: left;
    margin-right: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

/* 买家信息样式 */
.buyer-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
}

.buyer-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 5px;
}

.buyer-phone {
    font-weight: 500;
    font-size: 14px;
    color: #221E1F;
}

/* 金额样式 */
.amount-label {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 5px;
}

.amount-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

/* 状态样式 */
.status-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.status-text {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

.status-countdown {
    font-size: 12px;
    color: #ff4d4f;
}

/* 交易操作按钮样式 */
.trade-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* 按钮样式 */
.primary-btn {
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.default-btn {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.text-btn {
    font-size: 14px;
    color: #286CED;
}

/* 分页样式 */
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .trade-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }

    .search-form {
        flex-wrap: wrap;
    }

    .form-item-order-id,
    .form-item-name,
    .form-item-phone,
    .form-item-date {
        width: calc(50% - 5px);
    }
}
</style>